import { createActionGroup, props } from '@ngrx/store';
import { DeviceSyncStatus } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceSyncStatusResolverActions = createActionGroup({
  source: 'Device Sync Status resolver',
  events: {
    'Sync statuses requested': props<{ brandId: string; locationId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceSyncStatusApiActions = createActionGroup({
  source: 'Device Sync Status API',
  events: {
    'Sync statuses loaded': props<{ statuses: DeviceSyncStatus[] }>(),
    'Sync statuses loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SignalRActions = createActionGroup({
  source: 'SignalR',
  events: {
    'Status changed': props<{ status: DeviceSyncStatus }>(),
  },
});
